import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Menu } from './auth/menu.tsx';

function App() {
  return (
    <div>
      <Routes>
          <Route path='/' element={<Menu/>}/>
      </Routes>
    </div>
  );
}

export default App;
